"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.loadAccount = exports.buildTransactionBuilder = exports.buildCreateAccountOperation = exports.buildPaymentOperation = exports.broadcastTransaction = exports.fetchSigners = exports.fetchSequence = exports.fetchAccountNetworkInfo = exports.fetchOperations = exports.fetchAccount = exports.fetchBaseFee = void 0;
var bignumber_js_1 = require("bignumber.js");
var stellar_sdk_1 = __importStar(require("stellar-sdk"));
var env_1 = require("../../../env");
var currencies_1 = require("../../../currencies");
var logic_1 = require("../logic");
var errors_1 = require("@ledgerhq/errors");
var network_1 = require("../../../network");
var LIMIT = (0, env_1.getEnv)("API_STELLAR_HORIZON_FETCH_LIMIT");
var FALLBACK_BASE_FEE = 100;
var currency = (0, currencies_1.getCryptoCurrencyById)("stellar");
var server = new stellar_sdk_1["default"].Server((0, env_1.getEnv)("API_STELLAR_HORIZON"));
stellar_sdk_1["default"].HorizonAxiosClient.interceptors.request.use(network_1.requestInterceptor);
stellar_sdk_1["default"].HorizonAxiosClient.interceptors.response.use(function (response) {
    var _a, _b, _c;
    (0, network_1.responseInterceptor)(response);
    // FIXME: workaround for the Stellar SDK not using the correct URL: the "next" URL
    // included in server responses points to the node itself instead of our reverse proxy...
    // (https://github.com/stellar/js-stellar-sdk/issues/637)
    var url = (_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a._links) === null || _b === void 0 ? void 0 : _b.next) === null || _c === void 0 ? void 0 : _c.href;
    if (url) {
        var next = new URL(url);
        next.host = new URL((0, env_1.getEnv)("API_STELLAR_HORIZON")).host;
        response.data._links.next.href = next.toString();
    }
    return response;
});
var getFormattedAmount = function (amount) {
    return amount
        .div(new bignumber_js_1.BigNumber(10).pow(currency.units[0].magnitude))
        .toString(10);
};
var fetchBaseFee = function () { return __awaiter(void 0, void 0, void 0, function () {
    var baseFee, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, server.fetchBaseFee()];
            case 1:
                baseFee = _a.sent();
                return [3 /*break*/, 3];
            case 2:
                e_1 = _a.sent();
                baseFee = FALLBACK_BASE_FEE;
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, baseFee];
        }
    });
}); };
exports.fetchBaseFee = fetchBaseFee;
/**
 * Get all account-related data
 *
 * @async
 * @param {*} addr
 */
var fetchAccount = function (addr) { return __awaiter(void 0, void 0, void 0, function () {
    var account, balance, e_2, formattedBalance, spendableBalance;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                account = {};
                balance = {};
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, server.accounts().accountId(addr).call()];
            case 2:
                account = _a.sent();
                balance = account.balances.find(function (balance) {
                    return balance.asset_type === "native";
                });
                return [3 /*break*/, 4];
            case 3:
                e_2 = _a.sent();
                balance.balance = "0";
                return [3 /*break*/, 4];
            case 4:
                formattedBalance = (0, currencies_1.parseCurrencyUnit)(currency.units[0], balance.balance);
                return [4 /*yield*/, (0, logic_1.getAccountSpendableBalance)(formattedBalance, account)];
            case 5:
                spendableBalance = _a.sent();
                return [2 /*return*/, {
                        blockHeight: account.sequence ? Number(account.sequence) : undefined,
                        balance: formattedBalance,
                        spendableBalance: spendableBalance
                    }];
        }
    });
}); };
exports.fetchAccount = fetchAccount;
/**
 * Fetch all operations for a single account from indexer
 *
 * @param {string} accountId
 * @param {string} addr
 * @param {number} startAt - blockHeight after which you fetch this op (included)
 *
 * @return {Operation[]}
 */
var fetchOperations = function (accountId, addr, startAt) {
    if (startAt === void 0) { startAt = 0; }
    return __awaiter(void 0, void 0, void 0, function () {
        var operations, rawOperations, e_3, errorMsg, _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!addr || !addr.length) {
                        return [2 /*return*/, []];
                    }
                    operations = [];
                    rawOperations = {};
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, server
                            .operations()
                            .forAccount(addr)
                            .join("transactions")
                            .includeFailed(true)
                            .limit(LIMIT)
                            .cursor(startAt)
                            .call()];
                case 2:
                    rawOperations = _e.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_3 = _e.sent();
                    errorMsg = e_3 ? e_3.toString() : "";
                    if (e_3 instanceof stellar_sdk_1.NotFoundError || errorMsg.match(/status code 404/)) {
                        return [2 /*return*/, []];
                    }
                    if (errorMsg.match(/status code 4[0-9]{2}/)) {
                        return [2 /*return*/, new errors_1.LedgerAPI4xx()];
                    }
                    if (errorMsg.match(/status code 5[0-9]{2}/)) {
                        return [2 /*return*/, new errors_1.LedgerAPI5xx()];
                    }
                    if (e_3 instanceof stellar_sdk_1.NetworkError ||
                        errorMsg.match(/ECONNRESET|ECONNREFUSED|ENOTFOUND|EPIPE|ETIMEDOUT/) ||
                        errorMsg.match(/undefined is not an object/)) {
                        throw new errors_1.NetworkDown();
                    }
                    throw e_3;
                case 4:
                    if (!rawOperations || !rawOperations.records.length) {
                        return [2 /*return*/, []];
                    }
                    _b = (_a = operations).concat;
                    return [4 /*yield*/, (0, logic_1.rawOperationsToOperations)(rawOperations.records, addr, accountId)];
                case 5:
                    operations = _b.apply(_a, [_e.sent()]);
                    _e.label = 6;
                case 6:
                    if (!(rawOperations.records.length > 0)) return [3 /*break*/, 9];
                    return [4 /*yield*/, rawOperations.next()];
                case 7:
                    rawOperations = _e.sent();
                    _d = (_c = operations).concat;
                    return [4 /*yield*/, (0, logic_1.rawOperationsToOperations)(rawOperations.records, addr, accountId)];
                case 8:
                    operations = _d.apply(_c, [_e.sent()]);
                    return [3 /*break*/, 6];
                case 9: return [2 /*return*/, operations];
            }
        });
    });
};
exports.fetchOperations = fetchOperations;
var fetchAccountNetworkInfo = function (account) { return __awaiter(void 0, void 0, void 0, function () {
    var extendedAccount, numberOfEntries, ledger, baseReserve, fees, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, server
                        .accounts()
                        .accountId(account.freshAddress)
                        .call()];
            case 1:
                extendedAccount = _a.sent();
                numberOfEntries = extendedAccount.subentry_count;
                return [4 /*yield*/, server
                        .ledgers()
                        .ledger(extendedAccount.last_modified_ledger)
                        .call()];
            case 2:
                ledger = _a.sent();
                baseReserve = new bignumber_js_1.BigNumber((ledger.base_reserve_in_stroops * (2 + numberOfEntries)).toString());
                fees = new bignumber_js_1.BigNumber(ledger.base_fee_in_stroops.toString());
                return [2 /*return*/, {
                        family: "stellar",
                        fees: fees,
                        baseReserve: baseReserve
                    }];
            case 3:
                error_1 = _a.sent();
                return [2 /*return*/, {
                        family: "stellar",
                        fees: new bignumber_js_1.BigNumber(0),
                        baseReserve: new bignumber_js_1.BigNumber(0)
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.fetchAccountNetworkInfo = fetchAccountNetworkInfo;
var fetchSequence = function (a) { return __awaiter(void 0, void 0, void 0, function () {
    var extendedAccount;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.loadAccount)(a.freshAddress)];
            case 1:
                extendedAccount = _a.sent();
                return [2 /*return*/, extendedAccount
                        ? new bignumber_js_1.BigNumber(extendedAccount.sequence)
                        : new bignumber_js_1.BigNumber(0)];
        }
    });
}); };
exports.fetchSequence = fetchSequence;
var fetchSigners = function (a) { return __awaiter(void 0, void 0, void 0, function () {
    var extendedAccount, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, server
                        .accounts()
                        .accountId(a.freshAddress)
                        .call()];
            case 1:
                extendedAccount = _a.sent();
                return [2 /*return*/, extendedAccount.signers];
            case 2:
                error_2 = _a.sent();
                return [2 /*return*/, []];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.fetchSigners = fetchSigners;
var broadcastTransaction = function (signedTransaction) { return __awaiter(void 0, void 0, void 0, function () {
    var transaction, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                transaction = new stellar_sdk_1["default"].Transaction(signedTransaction, stellar_sdk_1["default"].Networks.PUBLIC);
                return [4 /*yield*/, server.submitTransaction(transaction, {
                        skipMemoRequiredCheck: true
                    })];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.hash];
        }
    });
}); };
exports.broadcastTransaction = broadcastTransaction;
var buildPaymentOperation = function (destination, amount) {
    var formattedAmount = getFormattedAmount(amount);
    return stellar_sdk_1["default"].Operation.payment({
        destination: destination,
        amount: formattedAmount,
        asset: stellar_sdk_1["default"].Asset.native()
    });
};
exports.buildPaymentOperation = buildPaymentOperation;
var buildCreateAccountOperation = function (destination, amount) {
    var formattedAmount = getFormattedAmount(amount);
    return stellar_sdk_1["default"].Operation.createAccount({
        destination: destination,
        startingBalance: formattedAmount
    });
};
exports.buildCreateAccountOperation = buildCreateAccountOperation;
var buildTransactionBuilder = function (source, fee) {
    var formattedFee = fee.toString();
    return new stellar_sdk_1["default"].TransactionBuilder(source, {
        fee: formattedFee,
        networkPassphrase: stellar_sdk_1["default"].Networks.PUBLIC
    });
};
exports.buildTransactionBuilder = buildTransactionBuilder;
var loadAccount = function (addr) { return __awaiter(void 0, void 0, void 0, function () {
    var e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!addr || !addr.length) {
                    return [2 /*return*/, null];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, server.loadAccount(addr)];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                e_4 = _a.sent();
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.loadAccount = loadAccount;
//# sourceMappingURL=horizon.js.map